import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function ModulesGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-slate-800/50',
    borderColor: 'border-slate-600/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Fundamentos de Aeronáutica y Atmósfera',
    subtitle: 'La base para entender todo lo demás',
    desc: 'Qué es la aeronáutica como disciplina; Atmósfera Estándar Internacional (ISA) y capas; presión, temperatura y densidad con la altitud; unidades aeronáuticas y conversiones; instrumentos que miden la atmósfera.',
    resuelve: 'El primer contacto con la aeronáutica puede ser el más transformador o el más aburrido. Este tomo convierte un tema técnico en algo comprensible y relevante.',
    resultado: 'Tus alumnos entienden la atmósfera como el entorno físico que define todo lo que ocurre en el vuelo, y pueden explicarlo con lenguaje técnico correcto.',
    tags: ['ISA', 'PRESIÓN', 'INSTRUMENTOS', 'ACTIVIDADES', 'EVALUACIÓN']
  }, {
    id: 2,
    lightColor: 'bg-slate-800/50',
    borderColor: 'border-slate-600/50',
    textColor: 'text-slate-300',
    emoji: '📗',
    title: 'Aerodinámica y Mecánica del Vuelo',
    subtitle: 'El tomo que más dudas genera y mejor resuelto está',
    desc: 'Cuatro fuerzas (sustentación, resistencia, empuje, peso); perfiles alares, ángulo de ataque, coeficientes; pérdida (stall); efecto suelo y turbulencias; flaps/slats/spoilers; superficies de control; estabilidad; factores de carga y virajes.',
    resuelve: 'Aerodinámica es el tema que más miedo da en el aula técnica y el que más preguntas genera. Este tomo lo hace visual, ordenado y completamente enseñable.',
    resultado: 'Tus alumnos dejan de memorizar fórmulas sin entenderlas y aprenden a razonar cómo y por qué se comporta una aeronave en el aire.',
    tags: ['FUERZAS', 'PERFILES', 'STALL', 'ESTABILIDAD', 'ESQUEMAS']
  }, {
    id: 3,
    lightColor: 'bg-slate-800/50',
    borderColor: 'border-slate-600/50',
    textColor: 'text-slate-300',
    emoji: '📙',
    title: 'Estructuras y Materiales Aeronáuticos',
    subtitle: 'Enseñá lo que van a tocar en el hangar',
    desc: 'Fuselaje/ala/empenaje/tren; aluminio, aleaciones, acero, titanio; tratamientos térmicos; compuestos CFRP/GFRP; fatiga y grietas; corrosión; filosofías safe-life/fail-safe/damage tolerance; NDT (ultrasonidos, líquidos penetrantes).',
    resuelve: 'Estructuras y materiales es donde más se traban los alumnos porque parece muy técnico y abstracto. Este tomo lo hace concreto y ordenado.',
    resultado: 'Tus alumnos aprenden a identificar materiales, entender su comportamiento estructural y aplicar los criterios de inspección de la industria.',
    tags: ['MATERIALES', 'FATIGA', 'CORROSIÓN', 'NDT', 'CASOS']
  }, {
    id: 4,
    lightColor: 'bg-slate-700/60',
    borderColor: 'border-slate-400/60',
    textColor: 'text-slate-200',
    emoji: '📕',
    title: 'Planta Motriz, Motores y Propulsión',
    subtitle: 'El módulo más complejo. El mejor explicado.',
    desc: 'Ciclo Brayton (turbina), ciclo Otto (pistón); turborreactor/turbofán/turbohélice/turboeje; FADEC; parámetros N1, N2, EGT, EPR; surge del compresor; hot start y windmilling; hélices; bypass ratio; sistemas de lubricación/ignición/arranque.',
    resuelve: 'Motores es el tema donde se decide la carrera de un técnico. Es el contenido con más preguntas en exámenes y el más demandado en el mercado laboral.',
    resultado: 'Tus alumnos comprenden cómo funciona un motor turbina o pistón de adentro hacia afuera, con el nivel de profundidad que exige la industria.',
    tags: ['TURBINAS', 'PISTÓN', 'FADEC', 'PARÁMETROS', 'ESQUEMAS'],
    badge: '⭐ EL MÁS POPULAR'
  }];
  const bonos = [{
    id: 1,
    title: 'Sistemas de a Bordo y Aviónica',
    valor: '$15.000 ARS',
    desc: 'Aviónica, hidráulicos, eléctricos, neumáticos, presurización, protección hielo/fuego; FMS, ADC, TCAS, ILS, ADS-B. Incluye actividades y evaluación.'
  }, {
    id: 2,
    title: 'Operaciones de Vuelo y Meteorología',
    valor: '$12.000 ARS',
    desc: 'Meteorología aeronáutica aplicada, fases del vuelo, MEL, CDL, documentación operacional.'
  }, {
    id: 3,
    title: 'Mantenimiento Aeronáutico y Aeronavegabilidad',
    valor: '$10.000 ARS',
    desc: 'Normativa ANAC, contexto EASA/FAA, AD, SB, CRS, reparaciones mayores/menores; Dirty Dozen (12 factores humanos) y modelo del queso suizo de James Reason. Evaluación incluida.'
  }, {
    id: 4,
    title: 'Proyecto Integrador y Aeronáutica del Futuro',
    valor: '$9.000 ARS',
    desc: 'Proyecto integrador con caso real; aviones eléctricos/híbridos, SAF, IA en mantenimiento; guía docente.'
  }];
  return <section className="py-20 bg-slate-900" data-id="element-153">
      <div className="container mx-auto px-4" data-id="element-154">
        <div className="text-center mb-16" data-id="element-155">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/80 text-slate-200 border border-slate-600/50 font-bold mb-6 text-[16px]" data-id="element-156">
            ✈️ LOS 4 TOMOS TÉCNICOS PREMIUM
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-157">
            Material completo para el aula
          </h2>
          <p className="text-slate-300 font-medium text-[16px]" data-id="element-158">
            No es teoría copiada de un manual en inglés. Es un sistema para que
            entres al aula con confianza.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-20" data-id="element-159">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-slate-700 bg-slate-950/80 overflow-hidden shadow-lg hover:shadow-xl hover:border-slate-500/50 transition-all flex flex-col h-full relative" data-id="element-160">
              {tomo.badge && <div className="absolute top-0 right-0 bg-slate-200 text-slate-900 font-bold text-xs px-3 py-1 rounded-bl-lg z-10" data-id="element-161">
                  {tomo.badge}
                </div>}
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-162">
                <div className="text-3xl" data-id="element-163">{tomo.emoji}</div>
                <div data-id="element-164">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-165">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-166">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-167">
                <p className="font-semibold text-slate-300 mb-3 pb-3 border-b border-slate-800" data-id="element-168">
                  {tomo.subtitle}
                </p>
                <p className="text-slate-300 text-sm leading-relaxed mb-4" data-id="element-169">
                  {tomo.desc}
                </p>
                <div className="bg-slate-900/50 p-3 rounded-lg mb-4 border border-slate-800/50" data-id="element-170">
                  <p className="text-xs text-slate-400 mb-1" data-id="element-171">
                    <strong data-id="element-172">¿Qué resuelve en el aula?</strong>
                  </p>
                  <p className="text-sm text-slate-300" data-id="element-173">{tomo.resuelve}</p>
                </div>
                <div className="bg-blue-900/20 p-3 rounded-lg mb-4 border border-blue-800/30" data-id="element-174">
                  <p className="text-xs text-blue-300 mb-1" data-id="element-175">
                    <strong data-id="element-176">Resultado:</strong>
                  </p>
                  <p className="text-sm text-slate-200" data-id="element-177">{tomo.resultado}</p>
                </div>
                <div className="mt-auto flex flex-wrap gap-1.5" data-id="element-178">
                  {tomo.tags.map((tag, j) => <span key={j} className="text-[10px] font-bold uppercase tracking-wider bg-slate-800 text-slate-300 px-2 py-1 rounded" data-id="element-179">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-12 border-t border-slate-800 pt-16" data-id="element-180">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/80 text-slate-200 border border-slate-600/50 font-bold mb-6 text-[16px]" data-id="element-181">
            🎁 LOS 4 BONOS ESTRATÉGICOS
          </div>
          <h2 className="md:text-4xl font-extrabold text-white mb-4 text-[22px]" data-id="element-182">
            Incluidos sin costo extra
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12" data-id="element-183">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-slate-700 bg-slate-950/80 p-6 flex flex-col h-full" data-id="element-184">
              <h4 className="font-bold text-slate-200 mb-2" data-id="element-185">BONO 0{bono.id}</h4>
              <h3 className="font-bold text-white text-lg mb-3" data-id="element-186">
                {bono.title}
              </h3>
              <p className="text-xs font-bold text-slate-400 mb-4 pb-3 border-b border-slate-800" data-id="element-187">
                Valor real: <span className="line-through" data-id="element-188">{bono.valor}</span> →{' '}
                <span className="text-slate-200" data-id="element-189">GRATIS</span>
              </p>
              <p className="text-slate-300 text-sm leading-relaxed flex-grow" data-id="element-190">
                {bono.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-slate-800/50 rounded-2xl p-6 md:p-8 border border-slate-600 text-center" data-id="element-191">
          <p className="text-slate-400 font-medium mb-2" data-id="element-192">
            Valor total de los 4 bonos: $46.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-193">
            Tu precio hoy: 🎁 GRATIS
          </p>
          <p className="text-slate-300 text-sm" data-id="element-194">
            Solo incluidos en esta oferta de lanzamiento.
          </p>
        </motion.div>
      </div>
    </section>;
}